const state = () => ({
	isPopup : false ,
	title : "",
	message : "",
	customCallbackName1 : null,
	customCallbackName2 : null,
	customCallback1 : null,
	customCallback2  : null,
});

const getters = {
	getIsPopup: state => state.isPopup,
	getTitle: state => state.title,
	getMessage: state => state.message,
	getCustomCallbackName1 : state => state.customCallbackName1,
	getCustomCallbackName2 : state => state.customCallbackName2,
	getCustomCallback1 : state => state.customCallback1,
	getCustomCallback2 : state => state.customCallback2,
};

const actions = {
	open({ commit }, popupData) {  // 팝업을 열떄 팝업 정보셋팅
		commit('SET_TITLE' , "");
		commit('SET_MESSAGE' , "");

		commit('SET_IS_POPUP' , true);
		commit('SET_TITLE' , popupData.title || "정보");
		commit('SET_MESSAGE' , popupData.message || "");
		commit('SET_CUSTOM_CALLBACK_NAME1' , popupData.customCallbackName1 || null);
		commit('SET_CUSTOM_CALLBACK_NAME2' , popupData.customCallbackName2 || null);
		commit('SET_CUSTOM_CALLBACK1' , popupData.customCallback1 || null);
		commit('SET_CUSTOM_CALLBACK2' , popupData.customCallback2 || null);
	},
	close({ commit }) {  // 팝업을 닫을떄 팝업정보 초기화
		commit('SET_IS_POPUP' , false);
    // commit('SET_TITLE' , "");
    // commit('SET_MESSAGE' , "");
		commit('SET_CUSTOM_CALLBACK_NAME1' , null);
		commit('SET_CUSTOM_CALLBACK_NAME2' , null);
		commit('SET_CUSTOM_CALLBACK1' , null);
		commit('SET_CUSTOM_CALLBACK2' , null);
	},
	
};

const mutations = {
	SET_IS_POPUP(state, payload) {
		state.isPopup = payload;
	},
	SET_TITLE(state, payload) {
		state.title = payload;
	},
	SET_MESSAGE(state, payload) {
		state.message = payload;
	},
	SET_CUSTOM_CALLBACK_NAME1(state, payload) {
		state.customCallbackName1 = payload;
	},
	SET_CUSTOM_CALLBACK_NAME2(state, payload) {
		state.customCallbackName2 = payload;
	},
	SET_CUSTOM_CALLBACK1(state, payload) {
		state.customCallback1 = payload;
	},
	SET_CUSTOM_CALLBACK2(state, payload) {
		state.customCallback2 = payload;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
